"use client";
import { useI18n } from "@wojo/localization";
import { useTripsAndDepartures } from "app/myaccount/_client/hooks";
import React from "react";
import { TripCard } from "../trip-card";
import { TripList } from "../trip-list";

export const CurrentTrips: React.FC = () => {
    const { currentTripsAndDepartures } = useTripsAndDepartures();
    const l10n = useI18n("account").account;
    const currentTripsAndDeparturesList = currentTripsAndDepartures.filter(
        (
            tripAndDeparture,
        ): tripAndDeparture is typeof tripAndDeparture &
            Required<Pick<typeof tripAndDeparture, "trip">> =>
            !!tripAndDeparture.trip,
    );

    if (currentTripsAndDeparturesList.length === 0) {
        return null;
    }

    return (
        <TripList title={l10n.current.l()}>
            {currentTripsAndDeparturesList.map((tripAndDeparture) => (
                <TripCard
                    key={tripAndDeparture.trip._id}
                    {...tripAndDeparture}
                />
            ))}
        </TripList>
    );
};
